__turbopack_context__.v({
  "bottomTrendingContainer": "BottomTrending-module__qpmjlG__bottomTrendingContainer",
  "contentWrapper": "BottomTrending-module__qpmjlG__contentWrapper",
  "row": "BottomTrending-module__qpmjlG__row",
  "rowItem": "BottomTrending-module__qpmjlG__rowItem",
  "sectionTitle": "BottomTrending-module__qpmjlG__sectionTitle",
  "separator": "BottomTrending-module__qpmjlG__separator",
});
